<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const page = usePage().value;

// Utility function to un-hyphenate and capitalize breadcrumb names
const formatBreadcrumbName = (name) => {
  return name
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const route = useRoute();

const breadcrumbs = computed(() => {
  const pathArray = route.path.split("/").filter((path) => path);
  const breadcrumbArray = pathArray.map((path, index) => {
    // Construct the full path for each breadcrumb
    const fullPath = `/${pathArray.slice(0, index + 1).join("/")}`;
    const routeMatch = route.matched.find(
      (matchedRoute) => matchedRoute.path === fullPath,
    );
    const name = routeMatch?.meta?.title || path;
    return {
      path: fullPath,
      name: formatBreadcrumbName(name),
    };
  });
  return breadcrumbArray;
});

// Computed property to check if the breadcrumb should be displayed
const showBreadcrumb = computed(() => {
  return route.path.split("/").filter((path) => path).length >= 2;
});
</script>

<template>
  <ClientOnly>
    <!-- Only show the breadcrumb if the URL path is at the 2nd level or deeper -->

    <nav
      v-show="showBreadcrumb"
      aria-label="breadcrumb"
      class="breadcrumb-wrap"
    >
      <ol class="breadcrumb">
        <li
          v-for="(crumb, index) in breadcrumbs"
          :key="index"
          class="breadcrumb-item"
          :class="{ active: index === breadcrumbs.length - 1 }"
          aria-current="page"
        >
          <!-- Render a link for all breadcrumbs except the last one -->
          <NuxtLink v-if="index < breadcrumbs.length - 1" :to="crumb.path">
            {{ crumb.name }}
          </NuxtLink>
          <!-- The last breadcrumb is plain text with an active class -->
          <span v-else>{{ crumb.name }}</span>
        </li>
      </ol>
    </nav>
  </ClientOnly>
</template>
